export class Validation {
  constructor() {
    this.invalid = true
    jQuery(($) => {
      this.$form = $('.wpcf7-form')

      // バリデーションメソッドの追加
      $.validator.addMethod(
        'furigana',
        function (value, element) {
          return this.optional(element) || /^[\u3040-\u309F\u30A0-\u30FFｧ-ﾝﾞﾟ]*$/.test(value)
        },
        'ひらがなもしくはカタカナで入力してください'
      )
      $.validator.addMethod(
        'phone',
        function (value, element) {
          if (value.includes('-')) {
            return this.optional(element) || /^\d{3}-\d{4}-\d{4}$|^\d{4}-\d{2}-\d{4}$/.test(value)
          } else {
            return this.optional(element) || /^\d{10}$|^\d{11}$/.test(value)
          }
        },
        '電話番号の形式で入力してください'
      )

      // バリデーションの初期化
      this.$form.each((index, form) => {
        $(form).validate({
          rules: {
            your_type: { required: true },
            job_type: { required: true },
            your_name: { required: true },
            your_name_kana: { required: true },
            your_email: { required: true, email: true },
            your_email_confirm: { required: true, email: true, equalTo: '[name=your_email]' },
            your_tel: { required: true, phone: true },
            your_tel_any: { phone: true },
            // your_message: { required: true },
            your_age: { required: true },
            your_file: { required: true },
          },
          messages: {
            your_type: { required: '入力必須項目です' },
            job_type: { required: '職種を選択してください' },
            your_name: { required: '氏名を入力してください' },
            your_name_kana: { required: '氏名（カナ）を入力してください' },
            your_email: { required: 'メールアドレスを入力してください', email: '正しいメールアドレスを入力してください' },
            your_email_confirm: { required: '確認用メールアドレスを入力してください', equalTo: 'メールアドレスが一致しません' },
            your_tel: { required: '電話番号を入力してください', phone: '正しい電話番号を入力してください' },
            // your_message: { required: 'メッセージを入力してください' },
            your_age: { required: '年齢を入力してください' },
            your_file: { required: 'ファイルを添付してください' },
          },
          errorElement: 'div',
          errorPlacement: function ($error, $element) {
            const isRadio = $element.attr('type') === 'radio'
            const $parent = isRadio ? $element.closest('.c-form__item') : $element.parent()
            $error.appendTo($parent)
          },
        })
      })

      // ラジオボタンによってファイル必須条件＆ラベル変更を切り替え
      this.$form.find('input[name="your_type"]').on('change', (e) => {
        const $currentForm = $(e.currentTarget).closest('.wpcf7-form') // 現在のフォームを取得
        const value = $(e.currentTarget).val()

        // `.mid` クラスを持つフォームの処理
        if ($currentForm.find('.mid').length) {
          this.handleMidForm($currentForm, value)
        }

        // `.new` クラスを持つフォームの処理
        if ($currentForm.find('.new').length) {
          this.handleNewForm($currentForm, value)
        }
      })

      this.$formButton = this.$form.find('.wpcf7-submit')

      // 送信ボタンのクリックイベント
      this.$formButton.on('click', (e) => {
        if (this.invalid) {
          e.preventDefault() // 最初にイベントをキャンセル

          // フォームのバリデーションを手動でトリガー
          if (this.$form.valid()) {
            if (!window.confirm('本当に送信しますか？')) {
              return
            }
            this.invalid = false
            this.$formButton.click()
          } else {
            alert('入力内容に不備があります')
            $('html, body').animate(
              {
                scrollTop: $('.c-form__contents').offset().top,
              },
              500
            )
          }
        }
      })

      // 送信後のページ遷移
      this.$form.on('wpcf7mailsent', () => {
        const pathname = location.pathname
        if (pathname.includes('entry-new')) {
          location.href = '/recruit/entry-new/complete/'
        } else if (pathname.includes('entry-mid')) {
          location.href = '/recruit/entry-mid/complete/'
        }
      })
    })
  }

  // `.new` クラス用の処理
  handleNewForm($form, value) {
    const $messageLabel = $form.find('.c-form__item.message .c-form__label')
    const $fileLabel = $form.find('.c-form__item.file .c-form__label')
    const $fileInput = $form.find('[name="your_file"]')
    const $messageInput = $form.find('[name="your_message"]')

    if (value === '担当者へお問い合わせ') {
      $messageLabel.text('お問い合わせ内容')
      $messageLabel.removeClass('-any').addClass('-required')

      $messageInput.rules('add', {
        required: true,
        messages: {
          required: '入力必須項目です',
        },
      })
    } else {
      $messageLabel.text('自由記入欄')
      $messageLabel.removeClass('-required').addClass('-any')
      $messageInput.rules('remove')
    }
  }
  // `.mid` クラス用の処理
  handleMidForm($form, value) {
    const $jobLabel = $form.find('.c-form__item.job .c-form__label')
    const $messageLabel = $form.find('.c-form__item.message .c-form__label')
    const $jobInput = $form.find('[name="your_job"]')
    const $messageInput = $form.find('[name="your_message"]')

    // 初期化：ルール削除 & ラベル状態リセット
    $jobInput.rules('remove')
    $messageInput.rules('remove')
    $jobLabel.removeClass('-required -any')
    $messageLabel.removeClass('-required -any')

    if (value === '応募') {
      $jobLabel.addClass('-required')
      $messageLabel.addClass('-any').text('自由記入欄')

      $jobInput.rules('add', {
        required: true,
        messages: {
          required: '入力必須項目です',
        },
      })
    } else if (value === '担当者へお問い合わせ') {
      $jobLabel.addClass('-any')
      $messageLabel.addClass('-required').text('お問い合わせ内容')

      $messageInput.rules('add', {
        required: true,
        messages: {
          required: '入力必須項目です',
        },
      })
    }
  }
}
